import styled from 'styled-components'

export const StyledWrapper = styled.div`
  overflow-y: auto;
  max-height: 60vh;  
`
